module.exports = __webpack_public_path__ + "res/arc_hunter.19db65abe194788106ae20fba0fa0765.webp";